(function () {
  'use strict';

  var root = document.querySelector('[data-mh-intro]');

  if (!root) return;

  var storageKey = 'majestyhub_intro_seen';
  var showOnce = root.dataset.showOnce === 'true';
  var duration = parseInt(root.dataset.duration || '0', 10);
  var startTime = Date.now();
  var closed = false;

  try {
    if (showOnce && sessionStorage.getItem(storageKey) === '1') {
      root.remove();
      return;
    }
  } catch (error) {}

  function closeIntro() {
    if (closed) return;

    closed = true;

    try {
      if (showOnce) {
        sessionStorage.setItem(storageKey, '1');
      }
    } catch (error) {}

    root.classList.add('mh-intro-is-closing');

    window.setTimeout(function () {
      root.remove();
    }, 900);
  }

  function closeAfterMinimumDuration() {
    var elapsed = Date.now() - startTime;
    var remaining = Math.max(0, duration - elapsed);

    window.setTimeout(closeIntro, remaining);
  }

  root
    .querySelectorAll('[data-mh-skip], [data-mh-enter]')
    .forEach(function (button) {
      button.addEventListener('click', closeIntro, { once: true });
    });

  var videos = root.querySelectorAll('video');

  videos.forEach(function (video) {
    video.addEventListener(
      'ended',
      closeAfterMinimumDuration,
      { once: true }
    );

    video.addEventListener(
      'error',
      function () {
        video.style.display = 'none';
      },
      { once: true }
    );
  });

  window.setTimeout(function () {
    if (!videos.length) {
      closeAfterMinimumDuration();
    }
  }, Math.max(duration, 1000));
})();